<table *ngIf="usersSource && usersSource.length > 0"
       mat-table multiTemplateDataRows
       [dataSource]="tableDS"
       class="mat-elevation-z5 full-width">

  <!-- Checkbox Column -->
  <ng-container matColumnDef="select">
    <th mat-header-cell *matHeaderCellDef class="column-header select">
      <mat-checkbox *ngIf="selectionChoices && selectionChoices.length"
                    [disabled]="!selectionModel || selectionModel.type == 'no-selection'"
                    (change)="$event ? selectAllToggle() : null"
                    [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()">
      </mat-checkbox>
    </th>
    <td mat-cell *matCellDef="let user">
      <mat-checkbox *ngIf="selectionModel && selectionModel.checker(user)"
                    (click)="$event.stopPropagation()"
                    (change)="$event ? selection.toggle(user) : null"
                    [checked]="selection.isSelected(user)">
      </mat-checkbox>
    </td>
  </ng-container>

  <!-- Identifier Column -->
  <ng-container matColumnDef="identifier">
    <th mat-header-cell *matHeaderCellDef class="column-header identifier" [class.mobile]="mobileView">
      <span *ngIf="showUsername; else showEmailHeader"
            i18n="Users List|Users List item 'identifier' title@@users-list-item-identifier-title">Identifier:</span>
      <ng-template #showEmailHeader>
        <span i18n="Users List|Users List item 'email' title@@users-list-item-email-title">Email:</span>
      </ng-template>
    </th>
    <td mat-cell *matCellDef="let user" class="column-content mat-body-strong"
        [class.text-secondary-color]="selectionModel && selectionModel?.highlighter(user)">
        <span class="word-wrap" [class.mat-small]="mobileView || (showPhone && !largeScreenView)"
        >{{showUsername ? user.email || user.username : user.email}}</span>
    </td>
  </ng-container>

  <!-- Phone Column -->
  <ng-container matColumnDef="phone">
    <th mat-header-cell *matHeaderCellDef class="column-header">
      <span i18n="Users List|Users List item 'phone' title@@users-list-item-phone-title">Phone:</span>
    </th>
    <td mat-cell *matCellDef="let user" class="column-content mat-body"
        [class.text-secondary-color]="selectionModel && selectionModel?.highlighter(user)">
      <span *ngIf="user.phone; else noPhone" class="word-wrap"
            [class.mat-small]="!largeScreenView">{{user.phone}}</span>
      <ng-template #noPhone><span>&#8211;</span></ng-template>
    </td>
  </ng-container>

  <!-- Name Column -->
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef class="column-header">
      <span i18n="Users List|Users List item 'name' title@@users-list-item-name-title">Name:</span>
    </th>
    <td mat-cell *matCellDef="let user" class="column-content mat-body"
        [class.text-secondary-color]="selectionModel && selectionModel?.highlighter(user)">
      <span *ngIf="user.firstName || user.lastName; else noName" class="word-wrap"
            [class.mat-small]="!largeScreenView">{{user.firstName}} {{user.lastName}}</span>
      <ng-template #noName><span>&#8211;</span></ng-template>
    </td>
  </ng-container>

  <!-- Grade Column -->
  <ng-container matColumnDef="grade">
    <th mat-header-cell *matHeaderCellDef class="column-header grade">
      <span i18n="Users List|Users List item 'grade' title@@users-list-item-grade-title">Grade:</span>
    </th>
    <td mat-cell *matCellDef="let user" class="column-content mat-body"
        [class.text-secondary-color]="selectionModel && selectionModel?.highlighter(user)">
      <span *ngIf="user.schoolGrade; else noGrade" class="word-wrap user-grade"
            [class.mat-small]="!largeScreenView">{{user.schoolGrade}}</span>
      <ng-template #noGrade><span>&#8211;</span></ng-template>
    </td>
  </ng-container>

  <!-- Region Column -->
  <ng-container matColumnDef="region">
    <th mat-header-cell *matHeaderCellDef class="column-header region">
      <span i18n="Users List|Users List item 'region' title@@users-list-item-region-title">Region:</span>
    </th>
    <td mat-cell *matCellDef="let user" class="column-content mat-body"
        [class.text-secondary-color]="selectionModel && selectionModel?.highlighter(user)">
      <span *ngIf="user.region; else noRegion" class="word-wrap"
            [class.mat-small]="!largeScreenView">{{regions.get(user.region)}}</span>
      <ng-template #noRegion><span>&#8211;</span></ng-template>
    </td>
  </ng-container>

  <!-- School Column -->
  <ng-container matColumnDef="school">
    <th mat-header-cell *matHeaderCellDef class="column-header school">
      <span i18n="Users List|Users List item 'school' title@@users-list-item-school-title">School:</span>
    </th>
    <td mat-cell *matCellDef="let user" class="column-content mat-body school"
        [class.text-secondary-color]="selectionModel && selectionModel?.highlighter(user)">
      <span *ngIf="user.schoolName; else noSchool" class="word-wrap mat-small">{{user.schoolName}}</span>
      <ng-template #noSchool><span>&#8211;</span></ng-template>
    </td>
  </ng-container>

  <!-- Teacher Column -->
  <ng-container matColumnDef="teacher">
    <th mat-header-cell *matHeaderCellDef class="column-header teacher">
      <span>{{localizeRole(TEACHER_ROLE)}}:</span>
    </th>
    <td mat-cell *matCellDef="let user" class="column-content mat-body"
        [class.text-secondary-color]="selectionModel && selectionModel?.highlighter(user)">
      <span *ngIf="user.teacher_id; else noTeacher" class="word-wrap"
            [class.mat-small]="!largeScreenView">{{user.teacher_first_name}} {{user.teacher_last_name}}</span>
      <ng-template #noTeacher><span>&#8211;</span></ng-template>
    </td>
  </ng-container>

  <!-- Enrolled Column -->
  <ng-container matColumnDef="enrolled">
    <th mat-header-cell *matHeaderCellDef class="column-header">
      <span i18n="Users List|Users List item 'enrolled-at' title@@users-list-item-enrolled-at-title">Enrolled At:</span>
    </th>
    <td mat-cell *matCellDef="let user" class="column-content mat-body"
        [class.text-secondary-color]="selectionModel && selectionModel?.highlighter(user)">
      <span class="word-wrap" [class.mat-small]="!largeScreenView">
        {{user.enrolledAt | date: showLocation ? 'short' : 'medium'}}
      </span>
    </td>
  </ng-container>

  <!-- Contact Column -->
  <ng-container matColumnDef="contact">
    <th mat-header-cell *matHeaderCellDef class="column-header contact">
      <span i18n="Users List|Users List item 'contact' title@@users-list-item-contact-title">Contact:</span>
    </th>
    <td mat-cell *matCellDef="let user" class="column-content mat-body">
      <mat-slide-toggle [color]="user.contactPerson ? 'primary' : 'accent'"
                        (toggleChange)="updateContact(user, !user.contactPerson)"
                        [checked]="user.contactPerson"
                        matTooltip="Is this a contact person?"
                        i18n-matTooltip="Users List|Users List item 'contact' person tooltip@@users-list-item-contact-person-tooltip">
      </mat-slide-toggle>
    </td>
  </ng-container>

  <!-- Status Column -->
  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef class="column-header status">
      <span
        i18n="Contests List|Contests list item 'user-status' title@@contests-list-item-user-status-title">Status:</span>
    </th>
    <td mat-cell *matCellDef="let user" class="column-content mat-body center-align">
      <span *ngIf="user.status; else noStatus" class="word-wrap mat-small"
            [class.color-green]="user.status == 'CONFIRMED' && user.emailVerified"
            [class.color-orange]="user.status == 'CONFIRMED' && !user.emailVerified"
            [class.color-warn]="user.status != 'CONFIRMED'">
        <mat-icon matTooltipClass="multiline-tooltip"
                  [matTooltip]="statusTooltip(user.status, user.emailVerified, user.paymentStatus)">
          {{user.status == 'CONFIRMED' ? 'verified_user' : 'warning_amber'}}
        </mat-icon>
      </span>
      <ng-template #noStatus><span>&#8211;</span></ng-template>
    </td>
  </ng-container>

  <!-- Payment Column -->
  <ng-container matColumnDef="payment">
    <th mat-header-cell *matHeaderCellDef class="column-header payment" [class.mobile]="mobileView">
      <span i18n="Contests List|Contests list item 'payment' title@@contests-list-item-payment-title">Payment:</span>
    </th>
    <td mat-cell *matCellDef="let user" class="column-content mat-body" [class.center-align]="mobileView">
      <div *ngIf="user.paymentStatus" class="word-wrap"
           [class.mat-small]="!largeScreenView"
           [class.color-green]="user.paymentStatus == paymentStatuses.successful"
           [class.color-warn]="user.paymentStatus == paymentStatuses.failed"
           [class.color-primary]="user.paymentStatus == paymentStatuses.pending">
        <span *ngIf="!mobileView">{{localizeStatus(user.paymentStatus)}}</span>
        <mat-icon *ngIf="mobileView"
                  [matTooltip]="localizeStatus(user.paymentStatus)">{{mobileStatusIcon(user.paymentStatus)}}</mat-icon>
      </div>
      <span *ngIf="!user.paymentStatus">&#8211;</span>

      <div [class.payment-actions]="mobileView">
        <a *ngIf="openForEnrol && contest && user.paymentStatus == paymentStatuses.failed"
           class="text-disabled-color mat-body word-wrap" [class.mat-small]="mobileView"
           (click)="$event.stopPropagation(); retryClicked(user, contest);"
           i18n="Contests List|Contests list item payment retry link title@@contests-list-item-payment-retry-link-title">
          try again
        </a>
        <a *ngIf="openForEnrol && contest && user.paymentStatus == paymentStatuses.scheduled"
           class="text-disabled-color mat-body word-wrap" [class.mat-small]="mobileView"
           (click)="$event.stopPropagation(); retryClicked(user, contest);"
           i18n="Contests List|Contests list item pay link title@@contests-list-item-pay-link-title">
          pay
        </a>
        <a *ngIf="contest && user.paymentStatus == paymentStatuses.pending"
           class="text-disabled-color mat-body word-wrap" [class.mat-small]="mobileView"
           (click)="$event.stopPropagation(); verifyClicked(user, contest);"
           i18n="Contests List|Contests list item check status link title@@contests-list-item-check-status-link-title">
          verify
        </a>
      </div>
    </td>
  </ng-container>

  <!-- Actions Column -->
  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef class="column-header actions">
    </th>
    <td mat-cell *matCellDef="let user" class="column-content mat-body">
      <mat-icon class="actions-icon"
                [matMenuTriggerFor]="menu"
                (click)="$event.stopPropagation();">more_vert
      </mat-icon>
      <mat-menu #menu="matMenu">
        <button *ngIf="editAllowed" mat-menu-item (click)="editUserDetails(user)">
          <mat-icon>manage_accounts</mat-icon>
          <span i18n="General|Edit action label@@general-edit-action-label">Edit</span>
        </button>
        <button *ngIf="showLocation && user.schoolId" mat-menu-item (click)="seeSchoolDetails(user.schoolId)">
          <mat-icon>school</mat-icon>
          <span i18n="Users List|Users List school details action label@@users-list-school-details-action-label">School Details</span>
        </button>
        <button *ngIf="setPasswordAllowed(user)" mat-menu-item (click)="resetPassword(user)">
          <mat-icon>vpn_key</mat-icon>
          <span i18n="General|Set password action label@@general-set-password-action-label">Set Password</span>
        </button>
        <button *ngIf="isChangingTeacherAllowed()" mat-menu-item (click)="selectTeacher(user)">
          <mat-icon>portrait</mat-icon>
          <span i18n="Select Teacher|Teacher selection title@@select-teacher-selection-title">Teacher Selection</span>
        </button>
        <button
          *ngIf="deleteAllowed && (selectionModel?.checker(user) || !deletePaymentCheck || user.paymentStatus != paymentStatuses.successful)"
          mat-menu-item (click)="removeUser(user)">
          <mat-icon>delete</mat-icon>
          <span i18n="General|Remove action label@@general-re move-action-label">Remove</span>
        </button>
        <button *ngIf="showApprove" mat-menu-item (click)="handleRequestAction(user, true)">
          <mat-icon>how_to_reg</mat-icon>
          <span i18n="General|Approve action label@@general-approve-action-label">Approve</span>
        </button>
        <button *ngIf="showApprove" mat-menu-item (click)="handleRequestAction(user, false)">
          <mat-icon>person_add_disabled</mat-icon>
          <span i18n="General|Reject action label@@general-reject-action-label">Reject</span>
        </button>
        <button *ngIf="isWatchingProgressAllowed(user)" mat-menu-item (click)="showParticipationStatus(user)">
          <mat-icon>sports_score</mat-icon>
          <span i18n="Exam Progress|Participation status title@@exam-progress-participation-status-title">Participation Status</span>
        </button>
        <a *ngIf="isWatchingResultsAllowed(user)"
           [routerLink]="getExamCardUrl(user)"
           target="_blank">
          <button mat-menu-item>
            <mat-icon>insert_chart_outlined</mat-icon>
            <span i18n="General|Results action label@@general-results-action-label">Results</span>
            <mat-icon class="external-url-icon">open_in_new</mat-icon>
          </button>
        </a>
      </mat-menu>
    </td>
  </ng-container>

  <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
  <ng-container matColumnDef="userDetail">
    <td mat-cell *matCellDef="let user" [attr.colspan]="(mobileView ? mobileColumns : columns).length">
      <div class="user-expanded-detail" [@detailExpand]="user.id == userDetails?.component?.user?.id ? 'expanded' : 'collapsed'">
        <list-item-details *ngIf="userDetails" class="full-width" [data]="userDetails"></list-item-details>
      </div>
    </td>
  </ng-container>

  <!-- Selection Model Row -->
  <ng-container matColumnDef="selectionModel">
    <th mat-header-cell *matHeaderCellDef [colSpan]="(mobileView ? mobileColumns : columns).length"
        class="column-header selection-model-selection">
      <div *ngIf="selectionChoices && selectionChoices.length" fxLayout="row">
        <div class="selection-model-holder">
          <item-select [roles]="roles"
                       label="Choose operation"
                       i18n-label="Users List|Choose operation label@@users-list-choose-operation-label"
                       [disabled]="!selectionChoices.length"
                       [compareWith]="compareSelections"
                       [displayWith]="displaySelection"
                       [loadWith]="loadSelections"
                       [selectedItem]="selectionModel"
                       (selected)="selectionModelChanged($event)"></item-select>
        </div>
        <div class="fill-space"></div>
        <div fxFlex="80px" class="selected-count-holder">
          <div *ngIf="selection.selected.length > 0">
            {{selection.selected.length}}
            &thinsp;
            <ng-container i18n="General|Selected label@@selected-label">selected</ng-container>
          </div>
        </div>
        <div class="fill-space"></div>
        <div class="selection-cta-holder">
          <app-button *ngIf="selectionModel"
                      [label]="selectionModel.cta_title"
                      color="primary"
                      [disabled]="!selection.selected.length"
                      (clicked)="usersSelectedCta.emit({users: selection.selected || [], model: selectionModel})"></app-button>
        </div>
      </div>
    </th>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="['selectionModel']"
      [class.no-selection-row]="!selectionChoices || !selectionChoices.length"></tr>
  <tr mat-header-row *matHeaderRowDef="mobileView ? mobileColumns : columns;"></tr>
  <tr mat-row *matRowDef="let user; columns: mobileView ? mobileColumns : columns;"
      class="user-row"
      [class.user-expanded-row]="userDetails === user"
      (click)="userDetails = userDetails?.component?.user?.id === user.id || (selectionModel && selectionModel.type != 'no-selection') ? null : getUserDetails(user)"></tr>
  <tr mat-row *matRowDef="let user; columns: ['userDetail']" class="user-detail-row"></tr>
</table>
